<template>
    <div>
        <div class="search-layout">
            <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryOnLoad="false" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="table-layout">
            <el-table :data="brandList" border style="width: 100%" @current-change="handleCurrentChange">
                <el-table-column align="center" prop="id" label="选择" width="50">
                    <template slot-scope="rows">
                        <el-radio v-model="brand.id" :label="rows.row.id">&nbsp;</el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="中文名称" align="left" sortable></el-table-column>
                <el-table-column prop="code" label="英文名称" align="left"></el-table-column>
                <el-table-column prop="dispName" label="显示名称" align="left"></el-table-column>
                <el-table-column prop="creatorName" label="创建人" align="left"></el-table-column>
            </el-table>
        </div>
        <div class="pagination-layout mt10">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import { getDefaultPageSizes } from '../../../src/app.conf'

    import comnApi from '../../api/comn'

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    let mockConfigData = {
        "queryFields": [{
            "type": "Text",
            "valueType": "String",
            "label": "中文名称",
            "code": "name",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "英文名称",
            "code": "code",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "显示名称",
            "code": "dispName",
            "basic": true
        }],
        "sortFields": []
    };

    export default {
        name: 'swb-brand-select',
        desc: '商品品牌列表',
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: 10,
                pageSizes: getDefaultPageSizes(),
                brandList: [],
                brand: {
                    id: null,
                    name: null
                },
                queryConfig: mockConfigData,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                }
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.getBrandList();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getBrandList();
            },
            getBrandList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                postData.filterItems = Utils.merge({}, this.queryModel.filterItems);
                postData.filterItems.deleted = false;
                let theLoad = MsgBox.loading();
                comnApi.getBrandPagedList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        self.brandList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            handleCurrentChange: function (val) {
                if(val != null) {
                    this.brand = {
                        id: val.id,
                        name: val.name,
                        code: val.code,
                        dispName: val.dispName
                    };
                }
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let result = {};
                if(this.brand != null) {
                    result.type = "info";
                    result.data = this.brand;
                } else {
                    result.type = "wran";
                    result.message = "请选择品牌";
                }
                return result;
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getBrandList();
            }
        },
    }

</script>





// WEBPACK FOOTER //
// src/compo/categ/BrandSelect.vue